/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LatestExchangeRates,
    LatestExchangeRatesFromJSON,
    LatestExchangeRatesFromJSONTyped,
    LatestExchangeRatesToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReadOnlyCurrency
 */
export interface ReadOnlyCurrency {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyCurrency
     */
    readonly id?: number;
    /**
     * 
     * @type {Array<LatestExchangeRates>}
     * @memberof ReadOnlyCurrency
     */
    readonly latestExchangeRate?: Array<LatestExchangeRates>;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyCurrency
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyCurrency
     */
    code: string;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyCurrency
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyCurrency
     */
    minorUnit?: number | null;
}

export function ReadOnlyCurrencyFromJSON(json: any): ReadOnlyCurrency {
    return ReadOnlyCurrencyFromJSONTyped(json, false);
}

export function ReadOnlyCurrencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyCurrency {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'latestExchangeRate': !exists(json, 'latest_exchange_rate') ? undefined : ((json['latest_exchange_rate'] as Array<any>).map(LatestExchangeRatesFromJSON)),
        'name': json['name'],
        'code': json['code'],
        'number': json['number'],
        'minorUnit': !exists(json, 'minor_unit') ? undefined : json['minor_unit'],
    };
}

export function ReadOnlyCurrencyToJSON(value?: ReadOnlyCurrency | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'code': value.code,
        'number': value.number,
        'minor_unit': value.minorUnit,
    };
}


